<template>
    <va-edit-layout>
        <Marketplace-form
            :id="id"
            :title="title"
            :item="item"
        ></Marketplace-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
